import {
  LINK_REFERRAL_DASHBOARD, LINK_REFERRAL_MERCHANTS, LINK_REFERRAL_TRX_ROOT,
} from "../../../../../constants/links";

const getIconPath = (name) => require(`../../../assets/svg/${name}`);

export const NAVIGATION_REFERRAL = [
  {
    name: 'Dashboard',
    link: LINK_REFERRAL_DASHBOARD,
    icon: getIconPath('Dashboard')
  },
  {
    name: 'Merchants',
    link: LINK_REFERRAL_MERCHANTS,
    icon: getIconPath('Merchants'),
  },
  {
    name: 'Transactions',
    link: LINK_REFERRAL_TRX_ROOT,
    icon: getIconPath('Transactions'),
  }
];
